import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../../lib/utils';
import { SpecraText } from '../ensigns/typography';
/** One label/value fact in operational and briefing rails. */ export function SpecraKeyValueRow({ className, dense = false, label, value, variant = 'default', ...props }) {
    if (variant === 'numeric') {
        return /*#__PURE__*/ _jsxs("div", {
            className: cn('flex flex-col gap-[var(--space-0-5)] border-b border-border/70 py-[var(--space-2)]', className),
            "data-variant": "numeric",
            ...props,
            children: [
                /*#__PURE__*/ _jsx(SpecraText, {
                    size: "body-sm",
                    tone: "secondary",
                    children: label
                }),
                /*#__PURE__*/ _jsx(SpecraText, {
                    as: "div",
                    className: "break-words tabular-nums",
                    size: "body-sm",
                    tone: "primary",
                    children: value
                })
            ]
        });
    }
    if (variant === 'fact') {
        return /*#__PURE__*/ _jsxs("div", {
            className: cn('flex items-start justify-between gap-x-[var(--space-3)]', dense ? 'py-[var(--space-1-5)]' : 'border-b border-border/70 py-[var(--space-2)]', className),
            "data-variant": "fact",
            ...props,
            children: [
                /*#__PURE__*/ _jsx(SpecraText, {
                    className: "min-w-0 shrink-0 basis-2/5",
                    size: "body-sm",
                    tone: "muted",
                    children: label
                }),
                /*#__PURE__*/ _jsx(SpecraText, {
                    as: "div",
                    className: "min-w-0 flex-1 break-words text-right font-medium",
                    size: "body-sm",
                    tone: "primary",
                    children: value
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: cn('flex flex-wrap items-start justify-between gap-x-3 gap-y-1', dense ? 'py-[var(--space-1-5)]' : 'border-b border-border/70 py-2', className),
        ...props,
        children: [
            /*#__PURE__*/ _jsx(SpecraText, {
                size: "body-sm",
                tone: "secondary",
                children: label
            }),
            /*#__PURE__*/ _jsx(SpecraText, {
                className: "break-words text-right",
                size: "caption",
                tone: "muted",
                children: value
            })
        ]
    });
}
